import React from 'react'

import { InfoIcon, Label } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../common'

import { Container, IconContainer } from './Notice.styles'

const PRE = `MAIN-PAYMENT-METHODS-SETTINGS-NOTICE`

export default function Notice() {
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  return (
    <Container>
      <IconContainer>
        <InfoIcon />
      </IconContainer>
      <Label>{t(`${PRE}-TEXT`)}</Label>
    </Container>
  )
}
